import { HelpLink } from 'elements/link/HelpLink'
import { Typography } from 'opensolar-ui'
import { useTranslate } from 'react-admin'

const Subtitle = () => {
  const translate = useTranslate()
  return (
    <Typography textVariant="body1" colorHex="#717171">
      {translate(
        'You can present your contract to the customer for them to review and sign by creating and editing a default contract template, which will be seen by the customer after accepting your proposal. You can also create additional templates that can be applied on a per project basis in the Online Proposal page in the Projects zone.'
      )}
      <HelpLink href="https://support.opensolar.com/hc/en-us/articles/12447973713935-How-to-configure-your-contract-in-OpenSolar" />
    </Typography>
  )
}

const ContractTitle = ({ record, translate, style }) => {
  return (
    <Typography textVariant="h5SemiBold" style={style}>
      {translate('Contract')} {record ? `"${record.title}"` : ''}
    </Typography>
  )
}

export default {
  list: { lazy: () => import('./Contracts'), component: 'ContractList' },
  edit: { lazy: () => import('./Contracts'), component: 'ContractEdit' },
  create: { lazy: () => import('./Contracts'), component: 'ContractCreate' },
  options: {
    create: {
      title: <Typography textVariant="h5SemiBold">Create Contract</Typography>,
      subtitle: null,
      breadCrumb: 'Create Contract',
    },
    list: {
      title: <Typography textVariant="h5SemiBold">My Contracts List</Typography>,
      subtitle: <Subtitle />,
      breadCrumb: 'Contracts',
    },
    edit: {
      title: <ContractTitle />,
      subtitle: null,
      breadCrumb: 'Edit Contract',
    },
  },
}
